import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { Canvas } from "../editor/Canvas.tsx";
import { DEFAULT_DOCUMENT_ID } from "../lib/documentsRegistry.ts";

/**
 * Lokal-läge: editorn utan inloggning. All data lagras i webbläsarens
 * IndexedDB via Yjs. Ingen backend krävs. Dokument-ID:t kommer från URL:en
 * (`/local/:documentId?`) och mappas 1:1 mot IndexedDB-databasen, så att
 * samma webbläsare kan ha parallella dokument som inte delar state.
 */
export function LocalCanvasRoute() {
  const params = useParams();
  const navigate = useNavigate();
  const rawId = params.documentId ?? DEFAULT_DOCUMENT_ID;
  const documentId = sanitizeId(rawId);

  const onSwitchDocument = useCallback(
    (id: string) => {
      if (id === DEFAULT_DOCUMENT_ID) {
        navigate("/local");
        return;
      }
      navigate(`/local/${encodeURIComponent(id)}`);
    },
    [navigate],
  );

  return (
    <div className="flex h-screen w-screen flex-col">
      <div className="min-h-0 flex-1">
        <Canvas
          key={documentId}
          documentId={documentId}
          onSwitchDocument={onSwitchDocument}
        />
      </div>
    </div>
  );
}

/** Tillåt bara tecken som fungerar i IndexedDB-nyckel och URL:en. */
function sanitizeId(id: string): string {
  const cleaned = id.replace(/[^a-zA-Z0-9_-]/g, "");
  return cleaned.length > 0 ? cleaned : DEFAULT_DOCUMENT_ID;
}
